export default {
  BASE_URL: "psm/hqp/admin",
  api: [
    {
      name: "listForAll",
      desc: "获取全部列表",
      method: "GET",
      path: "/listForAll"
    },
    {
      name: "listForWaitCheck",
      desc: "获取列表",
      method: "GET",
      path: "/listForWaitCheck"
    },
    {
      name: "list",
      desc: "获取列表",
      method: "GET",
      path: "/list"
    },
    {
      name: "listForCheckPass",
      desc: "获取已审核列表",
      method: "GET",
      path: "/listForCheckPass"
    },
    {
      name: "listForAccept",
      desc: "获取已评审列表",
      method: "GET",
      path: "/listForAccept"
    },
    {
      name: "listForReject",
      desc: "获取驳回列表",
      method: "GET",
      path: "/listForReject"
    },
    {
      name: "listQuitInfo",
      desc: "获取已退出列表",
      method: "GET",
      path: "/listQuitInfo"
    },
    {
      name: "listWaitForCertifi",
      desc: "获取待发证列表",
      method: "GET",
      path: "/listWaitForCertifi"
    },
    {
      name: "delete",
      desc: "删除",
      method: "GET",
      path: "/remove"
    },
    {
      name: "audit",
      desc: "审批",
      method: "POST",
      path: "/audit"
    },
    {
      name: "history",
      desc: "历史申报",
      method: "GET",
      path: "/history"
    },
    {
      name: "wait-cer",
      desc: "设置待发证",
      method: "POST",
      path: "/auditForWaitCer"
    },
    {
      name: "auditForExit",
      desc: "退出确认",
      method: "POST",
      path: "/auditForExit"
    },
    {
      name: "exportAll",
      desc: "导出全部",
      method: "POST",
      path: "/exportAll"
    },
    {
      name: "export",
      desc: "导出",
      method: "POST",
      path: "/export"
    },
    {
      name: "exportWaitCheck",
      desc: "导出",
      method: "POST",
      path: "/exportWaitCheck"
    },
    {
      name: "exportCheckPass",
      desc: "导出",
      method: "POST",
      path: "/exportCheckPass"
    },
    {
      name: "exportExit",
      desc: "导出",
      method: "POST",
      path: "/exportExit"
    },
    {
      name: "exportCertifi",
      desc: "导出",
      method: "POST",
      path: "/exportCertifi"
    },
    {
      name: "exportQuitInfo",
      desc: "导出-已退出页签",
      method: "POST",
      path: "/exportQuitInfo"
    },
    {
      name: "declare-update",
      desc: "更新申报信息",
      method: "POST",
      path: "/update"
    },
    {
      name: "listQuitInfo",
      desc: "更新申报信息",
      method: "GET",
      path: "/listQuitInfo"
    },
    //数据统计
    {
      name: "dictYear",
      desc: "申报年份数据字典",
      method: "GET",
      path: "/dict/year"
    },
    {
      name: "countCurrentList",
      desc: "申报中数据统计表",
      method: "POST",
      path: "/count/current"
    },
    {
      name: "countHistoryYearList",
      desc: "历史申报年度统计表",
      method: "POST",
      path: "/count/history/year"
    },
    {
      name: "countHistoryBatchList",
      desc: "历史申报年度统计表",
      method: "POST",
      path: "/count/history/batch"
    },
    {
      name: "currentExport",
      desc: "申报中数据统计表-导出",
      method: "POST",
      path: "/count/currentExport"
    },
    {
      name: "yearExport",
      desc: "历史申报年度统计表-导出",
      method: "POST",
      path: "/count/history/yearExport"
    },
    {
      name: "batchAuditForWaitCer",
      desc: "批量待发证（v1.3-第二批次）",
      method: "POST",
      path: "/batchAuditForWaitCer"
    },
    {
      name: "exit",
      desc: "退出申报",
      method: "POST",
      path: "/exit"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/api/psm/hqp/admin.js